import { configConstants } from '../constants';
import axios from 'axios';
import _ from 'lodash';
import { history, crmValidator, setHeaders } from 'helpers';
import objectToFormData from 'object-to-formdata';

export const stepcountsServices = {
  getStepCountLists,
  addStepCounts,
  updateStepCounts,
  deleteStepCounts,
  getListsProduct,
  getStepCountById,
  getRegionLists,
  getShopListsByRegion,
  downloadStepCountReport,
  importProduct
};

function getStepCountLists(reqParams) {
  let tmp = axios.get(configConstants.API_BACKEND_CRM + `/step-count?${reqParams}`, { headers: setHeaders() })
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return { status: true, data: response.data.data, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    }).catch(e => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
    })

  return tmp;
}

function downloadStepCountReport(reqParams) {
  let tmp = axios.get(configConstants.API_BACKEND_CRM + `/step-count/export/?${reqParams}`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        const urlDownload = _.get(response.data, "data.url")
        if(urlDownload){
           window.location.assign(urlDownload)
        }
        return { status: true, data: {}, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    }).catch(e => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
    })

  return tmp;
}

function addStepCounts(params) {console.log('params', params)
  let formData = new FormData();
  formData.set("data", JSON.stringify(params.data));
  formData.append('rewardDetailImg', params.rewardDetailImg);

  let tmp = axios.post(configConstants.API_BACKEND_CRM + `/step-count`, formData, { headers: setHeaders({ 'Content-Type': 'multipart/form-data' }) })
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return { status: true, data: response.data.data, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    }).catch(e => {
      return { status: false, data: {}, message: e.message };
    })
  return tmp;
}

function updateStepCounts(params) {console.log('params', params)
  let formData = new FormData();
  formData.set("data", JSON.stringify(params.data));
  formData.append('rewardDetailImg', params.rewardDetailImg);

  let tmp = axios.put(configConstants.API_BACKEND_CRM + `/step-count/${params._id}`, formData, { headers: setHeaders({ 'Content-Type': 'multipart/form-data' }) })
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return { status: true, data: response.data.data, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    }).catch(e => {
      return { status: false, data: {}, message: e.message };
    })
  return tmp;
}

function deleteStepCounts(params) {
  let tmp = axios.delete(configConstants.API_BACKEND_CRM + `/step-count/${params._id}/force`, { headers: setHeaders() })
    .then(response => {
      if (response.status.toString() === "200") {
        return { status: true, data: response.data.data, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    });

  return tmp;
}

function getListsProduct(params) {
  var tmp = axios.get(configConstants.API_BACKEND_CRM + `/list/products?${params}`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
    .then(response => {
      if (response.data.statusCode.toString() === "200") {
        return { status: true, data: response.data.data, message: response.data.message };
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push('/auth/login')
        return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
        return { status: false, data: {}, message: response.data.message };
      }
    })
    .catch(e => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
    });

  return tmp;
}

function getStepCountById(id) {
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/step-count/${id}`, { headers: setHeaders() })
        .then(response => {
            if (response.status.toString() === "200") {
                return { status: true, data: response.data.data, message: response.data.message };
            } else if (response.data.message === "UNAUTHORIZE") {
                history.push('/auth/login')
                return { status: false, data: {}, message: response.data.message };
            } else {
                return { status: false, data: {}, message: response.data.message };
            }
        });

    return tmp;
}

function getRegionLists(){
  let tmp = axios
    .get(configConstants.API_BACKEND_CRM + `/list/shop-region`, {
      headers: setHeaders({ "Charset": "utf-8" }),
    })
    .then((response) => {
      if (response.data.statusCode.toString() === "200") {
        return {
          status: true,
          data: response.data.data,
          message: response.data.message,
        }
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push("/auth/login")
        return {
          status: false,
          data: {},
          message: response.data.message,
          unAlert: true,
        }
      } else {
        return { status: false, data: {}, message: response.data.message }
      }
    })
    .catch((e) => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" }
    })

  return tmp
}


function getShopListsByRegion(params){
  let tmp = axios
    .get(configConstants.API_BACKEND_CRM + `/list/find-by-region?${params}`, {
      headers: setHeaders({ "Charset": "utf-8" }),
    })
    .then((response) => {
      if (response.data.statusCode.toString() === "200") {
        return {
          status: true,
          data: response.data.data,
          message: response.data.message,
        }
      } else if (response.data.statusCode.toString() === "400") {
        return {
          status: true,
          data: [],
          message: response.data.message,
        }
      } else if (response.data.message === "UNAUTHORIZE") {
        history.push("/auth/login")
        return {
          status: false,
          data: {},
          message: response.data.message,
          unAlert: true,
        }
      } else {
        return { status: false, data: {}, message: response.data.message }
      }
    })
    .catch((e) => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" }
    })

  return tmp
}

function importProduct(params) {
  try {
      let formData = new FormData();

      if (!crmValidator.isEmptyValue(params)) {
          _.forEach(params, function (value, key) {
              if (key === "fileImport") {
                  formData.append('file', value[0]);
              } else {
                  formData.append(key, value)
              }
          })
      }

      var tmp = axios.post(configConstants.API_BACKEND_CRM + '/step-count/import-product', formData, {
          headers: setHeaders({ 'Charset': 'utf-8' })
      })
          .then(response => {
              if (response.data.statusCode.toString() === "200") {
                  return {
                      status: true,
                      data: response.data.data,
                      message: response.data.message
                  };
              } else if (response.data.message === "UNAUTHORIZE") {
                  history.push('/auth/login')
                  return { status: false, data: {}, message: response.data.message, unAlert: true };
              } else {
                  return {
                      status: false,
                      data: response.data,
                      message: response.data.message
                  };
              }
          })
          .catch(error => {
              return {
                  status: false,
                  data: {
                      statusCode: 500
                  },
                  message: 'File not found, Please select file and try again.'
              };
          })
      return tmp;
  } catch (e) {
      return {
          status: false,
          data: {
              statusCode: 500
          },
          message: 'File not found, Please select file and try again.'
      };
  }
}